export const REPORTED_DATA = {
	PARENT_REPORT_LINKS: ["VOYAGE", "BDN", "CII DATA", "REPORT SUBMISSION"],
	DCS_LINKS: [
		"BDN SUMMARY",
		"IMO DCS DATA",
		"REPORT SUMMARY",
		"CARBON INTENSITY INDICATOR (CII)",
	],
	EUMRV_LINKS: ["EU MRV VOYAGES", "EU MRV PORT STAYS", "REPORT SUMMARY"],
	UKMRV_LINKS: ["UK MRV VOYAGES", "UK MRV PORT STAYS", "REPORT SUMMARY"],
	FEUMRV_LINKS: ["ENERGY MONITORING", "FEU CONTRIBUTION", "REPORT SUMMARY"],
	UKETS_LINKS: ["UK ETS VOYAGES", "UK ETS IN-PORT ACTIVITIES", "REPORT SUMMARY"],
};

export const REPORT_SUBMISSION_DATA = {
	CREATE_REPORT_TEXT: "Create Report",
	SUBMIT_ABS: "Submit to ABS",
	SUPPORTING_DOCS_NEEDED: "Supporting Documents Needed",
	SUBMITTED_ABS: "Report submitted to ABS",
	CREATE_REPORT_REPORT_STATUS: "Not Created",
	SUBMIT_ABS_REPORT_STATUS: "No Data Submitted",
	SUBMITTED_ABS_REPORT_STATUS: "Crosscheck In Progress",
	VERIFICATION_PROGRESS_REPORT_STATUS: "Verification In Progress",
	VERIFICATION_COMPLETE_REPORT_STATUS: "Verification Completed",
};

export const BDN_SUMMARY_DATA = {
	FUEL_TYPE: "Fuel oil Type/Mass(MT)",
	BDN: "BDN   (1)",
	REMAINING_OIL: "Correction for the Tank Oil Remaining   (2) ",
	OTHER_CORRECTION: "Other Correction   (3)",
	ANNUAL_FUEL_CONSUMPTION: "Annual fuel Consumption   (1) + (2) + (3)",
	EXPORT_TABLE: "Export Table",
};
